import { Box, Inline, Text, xcss } from '@atlaskit/primitives';
import Toggle from '@atlaskit/toggle';
import { DatabaseField } from '@databases/types/database';
import { shouldShowField } from '@databases/types/database/view';
import React from 'react';

import useView from '../../hooks/useView';

const fieldRowStyles = xcss({
  paddingTop: 'space.200',
  paddingBottom: 'space.200',
});

const fieldRowBorder = xcss({
  borderBottomWidth: '2px',
  borderBottomStyle: 'solid',
  borderBottomColor: 'color.border',
});

export interface FieldOptionProps {
  field: DatabaseField;
  handleToggleField: (field: DatabaseField) => void;
  showBorder?: boolean;
}

export const FieldOption: React.FC<FieldOptionProps> = ({
  field,
  handleToggleField,
  showBorder,
}) => {
  const { view } = useView();

  return (
    <Inline
      spread="space-between"
      alignBlock="center"
      xcss={[fieldRowStyles, showBorder && fieldRowBorder]}
    >
      <Text maxLines={1}>{field.name}</Text>
      <Box>
        <Toggle
          testId="field-toggle"
          isChecked={shouldShowField(view.settings.fields, field.id)}
          onChange={() => handleToggleField(field)}
        />
      </Box>
    </Inline>
  );
};

export default FieldOption;
